import React from 'react'
import { BoxProps } from '../Box'
import { ImageContainer, ImageWrapper } from './styles'

interface ImageBackgroundProps extends BoxProps {
  dominantColor?: string | null
  disableShadow?: boolean
}

function ImageBackground({ dominantColor, disableShadow, ...rest }: ImageBackgroundProps) {
  return (
    <ImageContainer dominantColor={dominantColor} {...rest}>
      <ImageWrapper disableShadow={disableShadow ?? false}>{rest.children}</ImageWrapper>
    </ImageContainer>
  )
}

export { ImageBackground, type ImageBackgroundProps }
